<template lang="pug">
  .single-solid-pie(ref="SingleSolidPie")
</template>
<script>
// title: '实心饼图',
// subTitle: 'Pa'
// max: 100
export default {
  name: 'SingleSolidPie',
  props: {
    opts: {
      type: Object,
      required: true
    },
    series: {
      required: false
    }
  },
  watch: {
    series: {
      deep: true,
      handler (val) {
        if (val) {
          this.updateSerise(val)
        }
      }
    }
  },
  computed: {
    option () {
      const SingleSolidPieDefault = {
        title: '实心饼图',
        subTitle: 'Pa',
        max: 100
      }
      const resu = Object.assign(SingleSolidPieDefault, this.opts)
      return resu
    }
  },
  data () {
    return {
      graph: null
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph () {
      this.graph = this.$echarts.init(this.$refs.SingleSolidPie)
      this.graph.showLoading()
    },
    updateSerise (serise) {
      const that = this
      const option = {
        backgroundColor: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0)'
            },
            {
              offset: 1,
              color: 'rgba(255, 255, 255, 0)'
            }
          ]
        },
        title: {
          text: this.option.title,
          left: '1%',
          top: '2%',
          textStyle: {
            color: '#000',
            fontWeight: '400'
          }
        },
        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        series: [
          {
            name: '中心',
            type: 'pie',
            selectedMode: 'single',
            hoverAnimation: false,
            radius: [0, '55.1%'],
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: '#243d91'
              },
              emphasis: {
                color: '#243d91'
              }
            },
            data: [
              {
                value: 0,
                name: '占位'
              }
            ]
          },
          {
            name: '中心',
            type: 'pie',
            hoverAnimation: false,
            radius: ['55%', '67%'],
            itemStyle: {
              normal: {
                color: '#5c8cd3'
              },
              emphasis: {
                color: '#5c8cd3'
              }
            },

            data: [
              {
                value: 2300,
                name: '有效数据',
                label: {
                  normal: {
                    position: 'center',
                    formatter: [
                      '{a|           ' + this.option.subTitle + '}',
                      '{c}'
                    ].join('\n'),
                    textStyle: {
                      color: '#fff',
                      fontSize: 30,
                      fontWeight: 300
                    },

                    rich: {
                      a: {
                        color: '#ddd',
                        fontSize: 20,
                        fontWeight: 300
                      }
                    }
                  }
                }
              },
              {
                value: 1000,
                name: '占位',
                label: {
                  normal: {
                    show: false
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                itemStyle: {
                  normal: {
                    color: 'rgba(0,0,0,0)'
                  },
                  emphasis: {
                    color: 'rgba(0,0,0,0)'
                  }
                }
              }
            ]
          }
        ]
      }
      option.series[1].data[0].value = serise.data1
      option.series[1].data[1].value = that.option.max - serise.data1
      that.graph.setOption(option)
      that.graph.hideLoading()
      window.addEventListener('resize', function () {
        that.graph.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.single-solid-pie {
  width: 100%;
  height: 100%;
}
</style>
